import clsx from "clsx";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  isExpanded: boolean;
  onChange: (expanded: boolean) => void;
  ["data-test-id"]?: string;
};

export const SearchConditionDisplayButton: FC<Props> = ({
  isExpanded,
  onChange,
  "data-test-id": dataTestId,
}: Props) => {
  const { t } = useTranslation();

  return (
    <button
      data-test-id={dataTestId ? `${dataTestId}-${isExpanded ? "close" : "open"}` : undefined}
      className={clsx("btn h-[20px]", isExpanded ? "btn-gray" : "btn-light-blue")}
      style={{ padding: "0 0.75rem" }}
      onClick={() => onChange(!isExpanded)}
    >
      {isExpanded ? t("hide_unnecessary_condition") : t("show_all_condition")}
    </button>
  );
};
